/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const holidaySchemePatchRequestSchema = z.object({
  description: z.string().nullish(),
  isDefault: z.boolean().nullish(),
  lastSyncedAt: z.iso.datetime().nullish(),
  locationIds: z.array(z.int().nullable()).nullish(),
  moveLocationMembers: z.boolean().nullish(),
  name: z.string().nullish(),
});
